export default {
  switchToOld: {
    title: 'На старую версию',
    description: 'Кликните, если есть трудности с текущей страницей.',
  },
  doneLabel: 'Закрыть',
  nextLabel: 'Далее',
  prevLabel: 'Назад',
}
